import { render, staticRenderFns } from "./RadioType.vue?vue&type=template&id=196abff8"
import script from "./RadioType.vue?vue&type=script&lang=ts"
export * from "./RadioType.vue?vue&type=script&lang=ts"
import style0 from "./RadioType.vue?vue&type=style&index=0&id=196abff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports